import React from 'react';
import {connect} from 'react-redux';
import RandomTeamsStackMarker from 'components/organisms/random-team-stacking/services/random-teams-stack-marker';
import {DesktopTeamsCombinations} from '../desktop-teams-combinations';

class TeamsCombinations extends DesktopTeamsCombinations {
    constructor(props) {
        super(props);
        this.marker = RandomTeamsStackMarker;
    }
}

function mapStatesToProps(state) {
    const {lineupsData, lineupTeamsCombinations} = state;

    return {
        rawLineups: lineupsData.rawLineups,
        lineupTeamsCombinations,
    };
}

let ComboSummary = connect(mapStatesToProps)(TeamsCombinations);

export {ComboSummary};
